export const TAX_DISPLAY_MODES = [
    'excluding',
    'including',
    'noDisplay'
];
export const DEFAULT_SALES_TAX_CONFIG = {
    enabled: false,
    displayMode: 'excluding',
    label: 'Sales tax',
    presets: []
};
